import React, { useState, useEffect } from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { cookieBanner } from '../../data/mock';
import { Button } from '../ui/button';

const CookieBanner = () => {
  const { language } = useLanguage();
  const [visible, setVisible] = useState(false);
  const content = cookieBanner[language];

  useEffect(() => {
    const accepted = localStorage.getItem('cookiesAccepted');
    if (!accepted) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookiesAccepted', 'true');
    setVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem('cookiesAccepted', 'false');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white z-[100] shadow-lg border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-4">
          <div className="flex-1">
            <h5 className="font-semibold text-gray-900 mb-2">{content.title}</h5>
            <p className="text-sm text-gray-600 leading-relaxed">
              {content.description}{' '}
              <a href="/politica-cookies" className="text-[#3eb8b3] hover:underline">
                {content.cookiesPolicy}
              </a>
            </p>
          </div>
          <div className="flex items-center gap-3 shrink-0">
            <button
              onClick={() => {}}
              className="text-gray-600 hover:text-gray-900 text-sm underline"
            >
              {content.configure}
            </button>
            <Button
              onClick={handleReject}
              className="bg-[#3eb8b3] hover:bg-[#2ea09b] text-white"
            >
              {content.reject}
            </Button>
            <Button
              onClick={handleAccept}
              className="bg-[#3eb8b3] hover:bg-[#2ea09b] text-white"
            >
              {content.accept}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
